'use client';

import { useMutation } from '@tanstack/react-query';

import { signInWithMeteorFallback } from '../server/meteor-signin.action';

interface SignInCredentials {
  email: string;
  password: string;
}

/**
 * Hook for signing in with Meteor password fallback
 *
 * This hook wraps the signInWithMeteorFallback server action in a mutation.
 * It first tries Supabase authentication, then falls back to Meteor password
 * verification if the user has a meteor_id.
 *
 * On successful Meteor password verification, the password is automatically
 * migrated to Supabase for future logins.
 */
export function useSignInWithMeteorFallback() {
  return useMutation({
    mutationFn: async (credentials: SignInCredentials) => {
      const result = await signInWithMeteorFallback(
        credentials.email,
        credentials.password,
      );

      if (!result.success) {
        throw new Error(result.error || 'Sign in failed');
      }

      return result;
    },
  });
}
